export default "__VITE_ASSET__51b08fc4__"